/**
 * @file 孵化器合同列表页面信息保存
 * @params data {
 *  tab：当前合同列表类别
 *  archivedPage: 归档合同当前页数
 *  archivedType：归档合同类型
 *  archivingPage: 待归档合同当前页数
 *  archivingType：待归档合同类型
 *  concludePage: 在签合同当前页数
 *  concludeType：在签合同类型
 *  incubatorUuid： 孵化器uuid
 * }
 */
const CONTRACT_TAB = 'CONTRACT_TAB';

export function setContractTab(params) {
  return dispatch =>
    dispatch({
      type: CONTRACT_TAB,
      data: params,
    });
}

export function contractTab(state = {}, action) {
  switch (action.type) {
    case CONTRACT_TAB:
      return action.data;
    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./src/store/modules/incubator/contract_tab.js